import { Button } from "@mui/material";
import { classes } from "common/theme/theme";
import { useTranslation } from "react-i18next";
import React, { FC } from "react";

type CreateCategoryDialogActionsProps = {
  onBack?: () => void;
  onCancel: () => void;
  disabled?: boolean;
} & (
  | {
      onConfirm: () => void;
      confirmLabel: string;
      confirmDisabled?: boolean;
      confirmLoading?: boolean;
    }
  | {
      onConfirm?: never;
      confirmLabel?: never;
      confirmDisabled?: never;
      confirmLoading?: never;
    }
);

export const CreateCategoryDialogActions: FC<
  CreateCategoryDialogActionsProps
> = ({
  onBack,
  onCancel,
  onConfirm,
  confirmLabel,
  confirmDisabled,
  confirmLoading,
  disabled,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={classes("flex gap-2 pt-4", {
        "justify-between": Boolean(onBack),
        "justify-end": !onBack,
      })}
    >
      {onBack && (
        <Button
          variant="text"
          color="inherit"
          disabled={disabled}
          onClick={onBack}
        >
          {t("utils.actions.backShort")}
        </Button>
      )}
      <div className="flex gap-2">
        <Button
          variant="text"
          color="inherit"
          disabled={disabled}
          onClick={onCancel}
        >
          {t("utils.actions.cancel")}
        </Button>
        {onConfirm && (
          <Button
            variant="contained"
            color="primary"
            loading={confirmLoading}
            disabled={confirmDisabled || disabled}
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        )}
      </div>
    </div>
  );
};
